
import Vue from "vue";
import { VilkenRoll } from "@/store/types";
import { EReceipt } from "@exp/vue";
import { FMessageBox } from "@fkui/vue";
import PrintButton from "@/components/Kvittens/PrintButton.vue";
import { KvittensSession } from "@/store/types";
import { kvittensSessionKey } from "@/constants";
import { scrollTo, focus } from "@fkui/logic";
import PrintedDocument from "@/components/Kvittens/PrintedDocument.vue";
import { SessionService } from "@/services/SessionService";

export default Vue.extend({
    name: "FkKvittens",
    components: {
        EReceipt,
        PrintButton,
        PrintedDocument,
        FMessageBox,
    },
    data: () => ({
        VilkenRoll,
        session: null as null | KvittensSession,
    }),
    computed: {
        isMyndighet(): boolean {
            if (this.session) {
                return this.session.vilkenroll === this.VilkenRoll.MYNDIGHET;
            }
            return false;
        },
    },
    created() {
        this.session = SessionService.getKvittensSession();
    },
    async mounted(): Promise<void> {
        this.preventNavigationBack();
        await this.focusErrorElement();
    },
    methods: {
        async focusErrorElement(): Promise<void> {
            await this.$nextTick();
            const kvittensError = this.$refs.kvittensError;
            if (kvittensError instanceof HTMLElement) {
                scrollTo(kvittensError);
                focus(kvittensError);
            }
        },
        preventNavigationBack(): void {
            window.history.pushState(null, "", window.location.href);
            window.onpopstate = async () => {
                this.setShowErrorMessage(true);
                window.history.pushState(null, "", window.location.href);
                await this.focusErrorElement();
            };
        },
        setShowErrorMessage(value: boolean): void {
            if (this.session) {
                this.session.showErrorMessage = value;
                sessionStorage.setItem(kvittensSessionKey, JSON.stringify(this.session));
            }
        },
    },
});
